import { render } from "./Child-Select.vue?vue&type=template&id=1f4c63cc&scoped=true"
import script from "./Child-Select.vue?vue&type=script&lang=js"
export * from "./Child-Select.vue?vue&type=script&lang=js"

import "./Child-Select.vue?vue&type=style&index=0&id=1f4c63cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4c63cc"]])

export default __exports__